// 🧭 Dizayn moslashtirish (Dizayn → Moslik) — mijoz shabloni bo'yicha butun ilovani bir uslubga keltirish.
// Ish SERVERDA (services/designAudit.js) bosqichma-bosqich ketadi — bu panel faqat ko'rsatadi va boshqaradi;
// brauzer/kompyuter yopilsa ham audit davom etadi. 5 soniyada yangilanadi (sahifa ko'rinib turganda).
import React from 'react';

const STATUS_STYLE = {
  pending: ['⏳', 'text-gray-500 dark:text-gray-400'], capturing: ['📸', 'text-sky-600 dark:text-sky-400'], captured: ['🖼', 'text-gray-700 dark:text-gray-200'],
  unreachable: ['🚫', 'text-gray-400'], auditing: ['🔍', 'text-sky-600 dark:text-sky-400'], audited: ['📊', 'text-gray-700 dark:text-gray-200'],
  queued: ['🧩', 'text-indigo-600 dark:text-indigo-400'], fixing: ['🛠', 'text-amber-600 dark:text-amber-400'], awaiting_approval: ['✋', 'text-amber-600 dark:text-amber-400'],
  fixed: ['✅', 'text-green-600 dark:text-green-400'], recapture: ['🔁', 'text-sky-600 dark:text-sky-400'], recapturing: ['📸', 'text-sky-600 dark:text-sky-400'],
  recaptured: ['🖼', 'text-sky-700 dark:text-sky-300'], reauditing: ['🔍', 'text-sky-600 dark:text-sky-400'], verified: ['🏁', 'text-green-700 dark:text-green-400'],
  error: ['⚠️', 'text-red-600 dark:text-red-400'],
};
const VERDICT = { ok: ['Mos', 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300'], minor: ['Kichik tuzatish', 'bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300'], major: ['Qayta qurish', 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300'] };
const ROLE_LABEL = (roles, key) => { const r = (roles || []).find(x => x.key === key); return r ? (r.title || r.key) : key; };
const scoreCls = (s) => s == null ? 'text-gray-400' : s >= 85 ? 'text-green-600 dark:text-green-400' : s >= 60 ? 'text-amber-600 dark:text-amber-400' : 'text-red-600 dark:text-red-400';
// ⬇ «Oldin | Keyin» — mijozga yuborish uchun bitta PNG (brauzerda canvas; API /media CORS bilan beriladi).
// Rasmlar fetch → blob orqali olinadi, shuning uchun canvas «tainted» bo'lmaydi.
async function downloadCompare(apiUrl, p) {
  const load = async (src) => {
    const r = await fetch(`${apiUrl}${src}`);
    if (!r.ok) throw new Error(`rasm ${r.status}`);
    const url = URL.createObjectURL(await r.blob());
    try {
      return await new Promise((res, rej) => { const im = new Image(); im.onload = () => res(im); im.onerror = () => rej(new Error('rasm ochilmadi')); im.src = url; });
    } finally { setTimeout(() => URL.revokeObjectURL(url), 5000); }
  };
  const [a, b] = await Promise.all([load(p.screenshot), load(p.afterScreenshot)]);
  const H = Math.min(1600, Math.max(a.naturalHeight, b.naturalHeight));
  const wa = Math.round(a.naturalWidth * H / a.naturalHeight), wb = Math.round(b.naturalWidth * H / b.naturalHeight);
  const pad = 48, gap = 96, head = p.title ? 96 : 24, foot = 84;
  const c = document.createElement('canvas');
  c.width = pad * 2 + wa + gap + wb; c.height = head + H + foot;
  const g = c.getContext('2d');
  g.fillStyle = '#FFFFFF'; g.fillRect(0, 0, c.width, c.height);
  g.fillStyle = '#111111'; g.textBaseline = 'middle'; g.textAlign = 'center';
  if (p.title) { g.font = '600 40px Inter, system-ui, sans-serif'; g.fillText(p.title, c.width / 2, head / 2 + 6, c.width - pad * 2); }
  g.drawImage(a, pad, head, wa, H);
  g.drawImage(b, pad + wa + gap, head, wb, H);
  g.strokeStyle = '#E5E7EB'; g.lineWidth = 2; g.strokeRect(pad, head, wa, H); g.strokeRect(pad + wa + gap, head, wb, H);
  g.font = '600 56px Inter, system-ui, sans-serif'; g.fillStyle = '#9CA3AF'; g.fillText('→', pad + wa + gap / 2, head + H / 2);
  g.font = '600 34px Inter, system-ui, sans-serif'; g.fillStyle = '#6B7280'; g.fillText('Oldin', pad + wa / 2, head + H + foot / 2);
  g.fillStyle = '#15803D'; g.fillText('Keyin', pad + wa + gap + wb / 2, head + H + foot / 2);
  const blob = await new Promise(res => c.toBlob(res, 'image/png'));
  const slug = String(p.title || `sahifa-${p.id}`).toLowerCase().replace(/[ʻʼ'`’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || `sahifa-${p.id}`;
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob); link.download = `${slug}-oldin-keyin.png`;
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(link.href), 10000);
}
const fmtTime = (t) => { try { const d = new Date(t); return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`; } catch (e) { return ''; } };

export default function DesignAuditPanel({ authFetch, apiUrl, projectId }) {
  const fRef = React.useRef(authFetch); fRef.current = authFetch;
  const [list, setList] = React.useState([]);
  const [auditId, setAuditId] = React.useState(null);
  const [view, setView] = React.useState(null);
  const [err, setErr] = React.useState('');
  const [busy, setBusy] = React.useState(false);
  const [newMode, setNewMode] = React.useState(false);
  const [imgs, setImgs] = React.useState([]);
  const [urls, setUrls] = React.useState('');
  const [note, setNote] = React.useState('');
  const [autoDeploy, setAutoDeploy] = React.useState(true);
  const [openPage, setOpenPage] = React.useState(null);
  const [showLog, setShowLog] = React.useState(false);
  const [showDs, setShowDs] = React.useState(false);
  const [lightbox, setLightbox] = React.useState(null);
  const [dlBusy, setDlBusy] = React.useState(null);
  const download = async (p) => {
    setDlBusy(p.id); setErr('');
    try { await downloadCompare(apiUrl, p); } catch (e) { setErr(`Rasmni yuklab bo'lmadi: ${e.message}`); }
    setDlBusy(null);
  };

  const loadList = React.useCallback(async () => {
    if (!projectId) return;
    try {
      const r = await fRef.current(`${apiUrl}/design-audits?projectId=${projectId}`);
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || 'Xatolik');
      const l = j.audits || [];
      setList(l);
      setAuditId(cur => (cur && l.some(a => a.id === cur)) ? cur : (l[0] ? l[0].id : null));
    } catch (e) { setErr(e.message); }
  }, [apiUrl, projectId]);
  React.useEffect(() => { setView(null); setAuditId(null); setNewMode(false); loadList(); }, [loadList]);

  const loadView = React.useCallback(async () => {
    if (!auditId) { setView(null); return; }
    try {
      const r = await fRef.current(`${apiUrl}/design-audits/${auditId}`);
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || 'Xatolik');
      setView(j); setErr('');
    } catch (e) { setErr(e.message); }
  }, [apiUrl, auditId]);
  React.useEffect(() => {
    loadView();
    const id = setInterval(() => { if (document.visibilityState === 'visible') loadView(); }, 5000);
    return () => clearInterval(id);
  }, [loadView]);

  const upload = async (files) => {
    for (const f of Array.from(files || []).slice(0, 10)) {
      try {
        const fd = new FormData(); fd.append('image', f);
        const r = await fRef.current(`${apiUrl}/upload`, { method: 'POST', body: fd });
        const j = await r.json().catch(() => ({}));
        if (j.imageUrl) setImgs(p => [...p, j.imageUrl].slice(0, 10)); else setErr(j.error || 'Rasm yuklanmadi');
      } catch (e) { setErr(e.message); }
    }
  };
  const start = async () => {
    setBusy(true); setErr('');
    try {
      const r = await fRef.current(`${apiUrl}/design-audits`, { method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ projectId, images: imgs, urls: urls.split(/\s+/).map(s => s.trim()).filter(Boolean), note, autoDeploy }) });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.error || 'Boshlanmadi');
      setNewMode(false); setImgs([]); setUrls(''); setNote('');
      await loadList(); setAuditId(j.id); setView(j);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };
  const act = async (what) => {
    if (!view) return;
    if (what === 'cancel' && !window.confirm("Dizayn moslashtirishni to'xtataymi? (Berilgan vazifalar o'z holicha qoladi)")) return;
    setBusy(true);
    try { const r = await fRef.current(`${apiUrl}/design-audits/${view.id}/${what}`, { method: 'POST' }); const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.error || 'Xatolik'); setView(j); loadList(); }
    catch (e) { setErr(e.message); } finally { setBusy(false); }
  };

  if (!projectId) return <div className="p-6 text-sm text-gray-500">Avval loyiha tanlang.</div>;
  const active = view && view.status === 'active';
  const showForm = newMode || (!list.length && !view);

  // Sahifalarni platforma → rol bo'yicha guruhlash
  const groups = [];
  if (view) {
    const m = new Map();
    for (const p of view.pages) { const k = `${p.platform}|${p.role}`; if (!m.has(k)) { m.set(k, { platform: p.platform, role: p.role, items: [] }); groups.push(m.get(k)); } m.get(k).items.push(p); }
  }
  const curId = view && view.current ? view.current.pageId : null;

  return (
    <div className="p-4 space-y-4 max-w-7xl mx-auto">
      {/* Sarlavha + audit tanlash */}
      <div className="flex flex-wrap items-center gap-2">
        <div className="min-w-0">
          <div className="text-base font-semibold text-gray-900 dark:text-white">🧭 Dizayn moslashtirish</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Shablon → hamma sahifalar rollar bo'yicha rasmga olinadi → solishtiriladi → vazifalar bittadan → qayta tekshiruv. Ish serverda ketadi — oynani yopsangiz ham davom etadi.</div>
        </div>
        <div className="flex-1" />
        {list.length > 0 && !showForm && (
          <select value={auditId || ''} onChange={e => setAuditId(Number(e.target.value))}
            className="text-sm border border-gray-200 dark:border-gray-700 rounded-lg px-2 py-1.5 bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            {list.map(a => <option key={a.id} value={a.id}>#{a.id} · {a.status} · {fmtTime(a.created_at)}</option>)}
          </select>
        )}
        {!showForm && !(view && view.status === 'active') && (
          <button onClick={() => setNewMode(true)} className="px-3 py-1.5 rounded-lg bg-primary-700 hover:bg-primary-800 text-white text-sm font-medium">➕ Yangi shablon</button>
        )}
      </div>
      {err && <div className="text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-lg px-3 py-2">{err}</div>}

      {/* YANGI AUDIT FORMASI */}
      {showForm && (
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-4 space-y-3">
          <div className="text-sm font-semibold text-gray-900 dark:text-white">Mijoz shabloni</div>
          <div className="text-xs text-gray-500 dark:text-gray-400">Rasm(lar): brendbuk, ekran namunalari, UI-kit sahifalari. Havola: shablon sayti (bir nechta sahifa ham bo'lishi mumkin — har biri yangi qatorda).</div>
          <div className="flex flex-wrap gap-2 items-center">
            {imgs.map((u, i) => (
              <div key={u} className="relative">
                <img src={`${apiUrl}${u}`} alt="" className="w-28 h-28 object-cover rounded border border-gray-200 dark:border-gray-700" />
                <button onClick={() => setImgs(p => p.filter((_, j) => j !== i))} className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-red-600 text-white text-xs">✕</button>
              </div>
            ))}
            <label className="w-28 h-28 flex flex-col items-center justify-center gap-1 rounded border-2 border-dashed border-gray-300 dark:border-gray-600 text-xs text-gray-500 cursor-pointer hover:border-primary-500">
              <span className="text-2xl">🖼</span>Rasm qo'shish
              <input type="file" accept="image/*" multiple className="hidden" onChange={e => { upload(e.target.files); e.target.value = ''; }} />
            </label>
          </div>
          <textarea value={urls} onChange={e => setUrls(e.target.value)} rows={2} placeholder="https://shablon-sayt.uz (ixtiyoriy)"
            className="w-full text-sm border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white" />
          <textarea value={note} onChange={e => setNote(e.target.value)} rows={2} placeholder="Izoh (ixtiyoriy): masalan «logotip va sariq-qora rang majburiy, illyustratsiyalar shart emas»"
            className="w-full text-sm border border-gray-200 dark:border-gray-700 rounded-lg px-3 py-2 bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-white" />
          <label className="flex items-start gap-2 text-sm text-gray-700 dark:text-gray-300">
            <input type="checkbox" checked={autoDeploy} onChange={e => setAutoDeploy(e.target.checked)} className="mt-1" />
            <span>Vazifalar avtomatik tasdiqlansin (merge + TEST muhit; prod'ga chiqmaydi). O'chirilsa har vazifani o'zingiz ✅ qilasiz va audit sizni kutadi.</span>
          </label>
          <div className="flex gap-2">
            <button disabled={busy || (!imgs.length && !urls.trim())} onClick={start}
              className="px-4 py-2 rounded-lg bg-primary-700 hover:bg-primary-800 disabled:opacity-50 text-white text-sm font-semibold">▶ Boshlash</button>
            {list.length > 0 && <button onClick={() => setNewMode(false)} className="px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 text-sm text-gray-700 dark:text-gray-200">Bekor</button>}
          </div>
        </div>
      )}

      {/* AUDIT KO'RINISHI */}
      {!showForm && view && (<>
        {/* Bosqichlar */}
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
          <div className="flex flex-wrap items-center gap-2 mb-3">
            <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${view.status === 'active' ? 'bg-sky-100 text-sky-800 dark:bg-sky-900/40 dark:text-sky-300' : view.status === 'done' ? 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300' : view.status === 'failed' ? 'bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300' : 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-300'}`}>
              {view.status === 'active' ? '● Ishlamoqda' : view.status === 'done' ? '✓ Tugadi' : view.status === 'failed' ? '✕ Xato' : view.status === 'cancelled' ? "To'xtatilgan" : view.status}
            </span>
            <span className="text-xs text-gray-500 dark:text-gray-400">#{view.id} · {fmtTime(view.createdAt)}{view.template && view.template.autoDeploy ? ' · avto-tasdiq' : ' · qo\'lda tasdiq'}</span>
            <div className="flex-1" />
            {active && <button disabled={busy} onClick={() => act('cancel')} className="px-2.5 py-1 rounded-lg border border-red-300 dark:border-red-700 text-red-700 dark:text-red-300 text-xs font-medium hover:bg-red-50 dark:hover:bg-red-900/30">⏹ To'xtatish</button>}
            {(view.status === 'failed' || view.status === 'cancelled') && <button disabled={busy} onClick={() => act('retry')} className="px-2.5 py-1 rounded-lg bg-primary-700 text-white text-xs font-medium hover:bg-primary-800">↻ Shu bosqichdan davom</button>}
          </div>
          <div className="flex flex-wrap gap-1.5">
            {view.stages.map((s, i) => (
              <div key={s.id} className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium border ${s.state === 'done' ? 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-800 dark:text-green-300' : s.state === 'current' ? 'bg-sky-50 dark:bg-sky-900/30 border-sky-300 dark:border-sky-700 text-sky-800 dark:text-sky-200 ring-2 ring-sky-300/50' : s.state === 'failed' ? 'bg-red-50 dark:bg-red-900/30 border-red-300 dark:border-red-700 text-red-700 dark:text-red-300' : 'bg-gray-50 dark:bg-gray-900 border-gray-200 dark:border-gray-700 text-gray-400'}`}>
                <span>{s.state === 'done' ? '✓' : s.state === 'current' ? <span className="animate-pulse">●</span> : s.state === 'failed' ? '✕' : i + 1}</span>
                <span>{s.title}</span>
              </div>
            ))}
          </div>
          {(view.current || view.wait || view.lastError) && (
            <div className="mt-3 space-y-1.5">
              {view.current && (() => { const p = view.pages.find(x => x.id === view.current.pageId); return (
                <div className="text-sm text-sky-800 dark:text-sky-200 bg-sky-50 dark:bg-sky-900/30 border border-sky-200 dark:border-sky-800 rounded-lg px-3 py-2 flex items-center gap-2">
                  <span className="animate-pulse">●</span>
                  <span>Hozir: {p ? <b translate="no">#{p.id} «{p.title}» ({ROLE_LABEL(view.roles, p.role)})</b> : null} {view.current.what}</span>
                </div>); })()}
              {view.wait && !view.current && <div className="text-sm text-amber-800 dark:text-amber-200 bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 rounded-lg px-3 py-2">⏳ {view.wait}</div>}
              {view.lastError && <div className="text-sm text-red-700 dark:text-red-300 bg-red-50 dark:bg-red-900/30 border border-red-200 dark:border-red-800 rounded-lg px-3 py-2">⚠️ {view.lastError}</div>}
            </div>
          )}
          {view.counts.total > 0 && (
            <div className="mt-3 flex flex-wrap gap-3 text-xs text-gray-600 dark:text-gray-300">
              <span>🗂 {view.counts.total} sahifa</span><span>📸 {view.counts.captured} rasm</span>{view.counts.unreachable > 0 && <span>🚫 {view.counts.unreachable} yetib bo'lmadi</span>}
              <span>📊 {view.counts.audited} baholandi</span>
              {view.counts.audited > 0 && <span>✅ {view.counts.ok} mos · 🔧 {view.counts.minor} kichik · 🔁 {view.counts.major} qayta qurish</span>}
              {view.counts.verified > 0 && <span>🏁 {view.counts.verified} qayta tekshirildi</span>}
            </div>
          )}
        </div>

        {/* Shablon + dizayn tizimi */}
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
          <button onClick={() => setShowDs(v => !v)} className="w-full flex items-center gap-2 text-sm font-semibold text-gray-900 dark:text-white">
            <span>{showDs ? '▾' : '▸'}</span> 🎨 Shablon va dizayn tizimi
            {view.designSystem && view.designSystem.colors && <span className="flex gap-1 ml-2">{Object.values(view.designSystem.colors).slice(0, 8).map((c, i) => <span key={i} title={c} className="w-4 h-4 rounded border border-gray-300 dark:border-gray-600" style={{ background: c }} />)}</span>}
          </button>
          {showDs && (
            <div className="mt-3 grid md:grid-cols-2 gap-3">
              <div className="flex flex-wrap gap-2">
                {[...(view.template.images || []), ...(view.template.shots || [])].map(u => (
                  <img key={u} src={`${apiUrl}${u}`} alt="" onClick={() => setLightbox({ a: u })} className="w-40 h-40 object-cover rounded border border-gray-200 dark:border-gray-700 cursor-zoom-in" />
                ))}
                {(view.template.urls || []).map(u => <a key={u} href={u} target="_blank" rel="noreferrer" className="text-xs text-primary-700 dark:text-primary-400 underline break-all">{u}</a>)}
              </div>
              {view.designSystem ? (
                <div className="text-xs text-gray-700 dark:text-gray-300 space-y-1.5">
                  <div>{view.designSystem.summary}</div>
                  {view.designSystem.typography && <div>🔤 <b>{view.designSystem.typography.family}</b> {view.designSystem.typography.weights}</div>}
                  {view.designSystem.colors && <div className="flex flex-wrap gap-2">{Object.entries(view.designSystem.colors).map(([k, c]) => <span key={k} className="inline-flex items-center gap-1"><span className="w-3.5 h-3.5 rounded border border-gray-300" style={{ background: c }} />{k} <code>{c}</code></span>)}</div>}
                  {view.designSystem.radius && <div>⬭ radius: {Object.entries(view.designSystem.radius).map(([k, v]) => `${k} ${v}`).join(' · ')}</div>}
                  {(view.designSystem.dos || []).length > 0 && <div>✔ {view.designSystem.dos.slice(0, 5).join(' · ')}</div>}
                  {(view.designSystem.donts || []).length > 0 && <div>✘ {view.designSystem.donts.slice(0, 5).join(' · ')}</div>}
                </div>
              ) : <div className="text-xs text-gray-400">Dizayn tizimi hali tayyor emas…</div>}
            </div>
          )}
        </div>

        {/* Reja (vazifalar) */}
        {view.plan.length > 0 && (
          <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
            <div className="text-sm font-semibold text-gray-900 dark:text-white mb-2">🛠 Vazifalar rejasi ({view.plan.filter(i => i.status === 'done').length}/{view.plan.length})</div>
            <div className="space-y-1">
              {view.plan.map((it, i) => (
                <div key={it.id} className={`flex items-center gap-2 text-xs px-2 py-1.5 rounded ${it.status === 'running' ? 'bg-amber-50 dark:bg-amber-900/20' : ''}`}>
                  <span className="w-5 text-center">{it.status === 'done' ? '✅' : it.status === 'running' ? <span className="animate-pulse">🛠</span> : it.status === 'failed' ? '❌' : `${i + 1}.`}</span>
                  <span className="flex-1 min-w-0 truncate text-gray-800 dark:text-gray-200" title={it.title}>{it.kind === 'theme' ? '🎨 ' : ''}{it.title}</span>
                  {it.taskId && <span className="font-mono text-primary-700 dark:text-primary-400">#{it.taskId}</span>}
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Sahifalar jadvali — platforma → rol */}
        {groups.map(g => (
          <div key={`${g.platform}|${g.role}`} className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden">
            <div className="px-3 py-2 bg-gray-50 dark:bg-gray-900/60 border-b border-gray-200 dark:border-gray-700 text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
              <span>{g.platform === 'mobile' ? '📱' : '🌐'}</span>
              <span translate="no">{ROLE_LABEL(view.roles, g.role)}</span>
              <span className="text-xs font-normal text-gray-500">{g.items.length} sahifa · {g.items.filter(p => ['fixed', 'verified'].includes(p.status) || p.verdict === 'ok').length} tayyor</span>
            </div>
            <div className="divide-y divide-gray-100 dark:divide-gray-700">
              {g.items.map(p => {
                const [ic, cls] = STATUS_STYLE[p.status] || ['•', 'text-gray-500'];
                const cur = p.id === curId;
                const open = openPage === p.id;
                return (
                  <div key={p.id} className={cur ? 'bg-sky-50 dark:bg-sky-900/20 ring-2 ring-inset ring-sky-300 dark:ring-sky-700' : ''}>
                    <div className="flex items-center gap-3 px-3 py-2 cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700/40" onClick={() => setOpenPage(open ? null : p.id)}>
                      <div className="w-10 h-14 shrink-0 rounded overflow-hidden bg-gray-100 dark:bg-gray-900 border border-gray-200 dark:border-gray-700">
                        {(p.afterScreenshot || p.screenshot) && <img src={`${apiUrl}${p.afterScreenshot || p.screenshot}`} alt="" className="w-full h-full object-cover object-top" />}
                      </div>
                      <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium text-gray-900 dark:text-white truncate"><span translate="no">{p.title}</span> <span className="text-xs text-gray-400 font-mono">#{p.id}</span></div>
                        <div className="text-[11px] text-gray-500 dark:text-gray-400 truncate">{[p.route, p.file].filter(Boolean).join(' · ')}</div>
                      </div>
                      <div className={`text-xs font-medium whitespace-nowrap ${cls}`}>{cur ? <span className="animate-pulse">{ic}</span> : ic} {p.statusLabel}</div>
                      <div className="w-24 text-right text-xs whitespace-nowrap">
                        {p.score != null && <span className={`font-semibold ${scoreCls(p.score)}`}>{p.score}</span>}
                        {p.afterScore != null && <> → <span className={`font-semibold ${scoreCls(p.afterScore)}`}>{p.afterScore}</span></>}
                      </div>
                      <div className="w-28 text-right">{p.verdict && VERDICT[p.verdict] && <span className={`text-[11px] px-1.5 py-0.5 rounded ${VERDICT[p.verdict][1]}`}>{VERDICT[p.verdict][0]}</span>}</div>
                      <div className="w-14 text-right text-xs font-mono text-primary-700 dark:text-primary-400">{p.taskId ? `#${p.taskId}` : ''}</div>
                    </div>
                    {open && (
                      <div className="px-3 pb-3 grid md:grid-cols-[auto_1fr] gap-3">
                        <div>
                        <div className="flex gap-2">
                          {p.screenshot && <figure className="text-center"><img src={`${apiUrl}${p.screenshot}`} alt="" onClick={() => setLightbox({ a: p.screenshot, b: p.afterScreenshot, p })} className="w-36 rounded border border-gray-200 dark:border-gray-700 cursor-zoom-in" /><figcaption className="text-[10px] text-gray-500 mt-1">Oldin</figcaption></figure>}
                          {p.afterScreenshot && <figure className="text-center"><img src={`${apiUrl}${p.afterScreenshot}`} alt="" onClick={() => setLightbox({ a: p.screenshot, b: p.afterScreenshot, p })} className="w-36 rounded border border-green-300 dark:border-green-700 cursor-zoom-in" /><figcaption className="text-[10px] text-gray-500 mt-1">Keyin</figcaption></figure>}
                        </div>
                        {p.screenshot && p.afterScreenshot && (
                          <button disabled={dlBusy === p.id} onClick={() => download(p)} className="mt-2 w-full px-2 py-1 rounded-lg border border-gray-300 dark:border-gray-600 text-xs font-medium text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-60">
                            {dlBusy === p.id ? '⏳ Tayyorlanmoqda…' : '⬇ Yuklab olish (oldin/keyin)'}
                          </button>
                        )}
                        </div>
                        <div className="text-xs text-gray-700 dark:text-gray-300 space-y-1.5 min-w-0">
                          {p.reach && <div className="text-gray-500">🧭 {p.reach}</div>}
                          {p.note && <div className="text-amber-700 dark:text-amber-300">📝 {p.note}</div>}
                          {p.diffs && p.diffs.summary && <div className="font-medium">{p.diffs.summary}</div>}
                          {p.diffs && (p.diffs.diffs || []).map((d, i) => (
                            <div key={i} className="flex gap-1.5"><span className={d.severity === 'high' ? 'text-red-500' : d.severity === 'medium' ? 'text-amber-500' : 'text-gray-400'}>●</span>
                              <span><b>{d.area}:</b> {d.current} → <span className="text-green-700 dark:text-green-400">{d.expected}</span></span></div>
                          ))}
                          {p.diffs && (p.diffs.keep || []).length > 0 && <div className="text-gray-500">✔ Mos: {p.diffs.keep.join(' · ')}</div>}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        ))}
        {view.pages.length === 0 && view.status === 'active' && <div className="text-sm text-gray-500 dark:text-gray-400 px-1">Sahifalar ro'yxati tuzilmoqda…</div>}

        {/* Jurnal */}
        <div className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
          <button onClick={() => setShowLog(v => !v)} className="text-sm font-semibold text-gray-900 dark:text-white">{showLog ? '▾' : '▸'} 📜 Jurnal ({view.log.length})</button>
          {showLog && (
            <div className="mt-2 max-h-72 overflow-auto text-xs font-mono space-y-0.5 text-gray-700 dark:text-gray-300">
              {[...view.log].reverse().map((l, i) => <div key={i}><span className="text-gray-400">{fmtTime(l.at)}</span> {l.text}</div>)}
            </div>
          )}
        </div>
      </>)}

      {lightbox && (
        <div className="fixed inset-0 z-[70] bg-black/85 flex items-center justify-center gap-4 p-4" onClick={() => setLightbox(null)}>
          {lightbox.a && <figure className="h-full flex flex-col items-center"><img src={`${apiUrl}${lightbox.a}`} alt="" className="max-h-[90vh] max-w-[45vw] object-contain rounded" /><figcaption className="text-white text-xs mt-2">{lightbox.b ? 'Oldin' : ''}</figcaption></figure>}
          {lightbox.b && <figure className="h-full flex flex-col items-center"><img src={`${apiUrl}${lightbox.b}`} alt="" className="max-h-[90vh] max-w-[45vw] object-contain rounded" /><figcaption className="text-white text-xs mt-2">Keyin</figcaption></figure>}
          {lightbox.a && lightbox.b && lightbox.p && (
            <button disabled={dlBusy === lightbox.p.id} onClick={(e) => { e.stopPropagation(); download(lightbox.p); }} className="absolute bottom-4 left-1/2 -translate-x-1/2 px-3 py-1.5 rounded-lg bg-white text-gray-900 text-sm font-medium shadow hover:bg-gray-100 disabled:opacity-60">
              {dlBusy === lightbox.p.id ? '⏳ Tayyorlanmoqda…' : '⬇ Yuklab olish (oldin/keyin)'}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
